"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const glightbox_1 = __importDefault(require("glightbox"));
const videoTeasers = Array.from(document.querySelectorAll('.c-video'));
const documentBody = document.querySelector('body');
if (videoTeasers) {
    const initVideo = (teaser) => {
        const videoString = teaser.getAttribute('data-ssh-video-url');
        let videoUrl = new URL(videoString);
        let params = new URLSearchParams(videoUrl.search);
        let videoId = params.get("v");
        let iframeUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&rel=0`;
        const contentArea = teaser.querySelector('.c-video__thumbnail');
        if (contentArea) {
            contentArea.outerHTML = `<iframe width="100%" height="550" class="o-embed__content o-ratio__content" src="${iframeUrl}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
        }
        contentArea.classList.toggle('c-video__video');
    };
    const rememberConsent = (name, value, days) => {
        let expirationDate = '';
        if (days) {
            let date = new Date();
            date.setTime(+date + (days * (24 * 60 * 60 * 1000)));
            expirationDate = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expirationDate + "; path=/";
    };
    videoTeasers.forEach((videoTeaser) => {
        const videoLink = videoTeaser.querySelector('a');
        if (videoLink) {
            videoLink.addEventListener("click", (event) => {
                // If user decided to remember his decision, skip the GDPR flow and show the video instantly.
                if (getCookie('sshgmbh')) {
                    initVideo(videoLink.closest('figure.c-video'));
                }
                else {
                    const lightbox = new glightbox_1.default({ selector: null });
                    lightbox.insertSlide({
                        width: '700px',
                        height: 'auto',
                        content: videoTeaser.nextElementSibling.outerHTML,
                    });
                    lightbox.open();
                    const openLightbox = document.getElementById('glightbox-slider');
                    const modal = openLightbox.querySelector('.c-modal');
                    modal.classList.remove('hidden');
                    const modalAcceptButton = openLightbox.querySelector('[data-ssh-gdpr-accept]');
                    const modalDenyButton = openLightbox.querySelector('[data-ssh-gdpr-deny]');
                    const modalRememberDecision = openLightbox.querySelector('[data-ssh-gdpr-remember-decision]');
                    modalAcceptButton.addEventListener("click", () => {
                        if (modalRememberDecision.checked) {
                            rememberConsent('sshgmbh', 'youtube-consent', 365);
                        }
                        lightbox.close();
                        initVideo(videoLink.closest('figure.c-video'));
                        event.preventDefault();
                    });
                    modalDenyButton.addEventListener("click", () => {
                        lightbox.close();
                        event.preventDefault();
                    });
                }
                event.preventDefault();
            });
        }
    });
}
function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
function killCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
const compareConsentStringsAndRemoveConsent = () => {
    const today = new Date();
    const oneMonthDateString = new Date(new Date().setDate(today.getDate() - 30));
    if (today < oneMonthDateString) {
        killCookie('sshgmbh');
    }
};
// Recheck the users' consent on page load and kick the consent to opt into YT video if older than a month.
documentBody.addEventListener("load", () => {
    compareConsentStringsAndRemoveConsent();
});
exports.default = {};
